module.exports = __webpack_public_path__ + "media/apps/instashopper-ea7b313b.png";